const course = [
    {
        path: '/course',
        name: 'course',
        component: () => import('@/view/course/Index')
    },
    {
        path: '/course/:id',
        name: 'courseDetails',
        component: () => import('@/view/course/Details')
    },
]
export default course